import { render, staticRenderFns } from "./about.vue?vue&type=template&id=4e960eb9&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&lang=css&"
import style1 from "./about.vue?vue&type=style&index=1&id=4e960eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e960eb9",
  null
  
)

export default component.exports